"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChainSupported = exports.ALLCHAINS = exports.nativeTokenDetails = exports.txnBaseUrl = exports.explorerBaseUrls = void 0;
exports.explorerBaseUrls = {
    ETH: 'https://etherscan.io',
    POLYGON: 'https://polygonscan.com',
    AVALANCHE: 'https://snowtrace.io',
    ARBITRUM: 'https://arbiscan.io',
    BINANCE: 'https://bscscan.com',
    OPTIMISM: 'https://optimistic.etherscan.io',
    FANTOM: 'https://ftmscan.com',
    SOLANA: 'https://solscan.io',
    APTOS: 'https://explorer.aptoslabs.com',
    NEO: 'https://neo3.neotube.io',
    SUI: 'https://suiexplorer.com/?network=mainnet',
    FUSE: 'https://explorer.fuse.io',
    MUMBAI: 'https://mumbai.polygonscan.com',
};
exports.txnBaseUrl = {
    ETH: `${exports.explorerBaseUrls.ETH}/tx`, // /txHash
    POLYGON: `${exports.explorerBaseUrls.POLYGON}/tx`,
    AVALANCHE: `${exports.explorerBaseUrls.AVALANCHE}/tx`,
    ARBITRUM: `${exports.explorerBaseUrls.ARBITRUM}/tx`,
    BINANCE: `${exports.explorerBaseUrls.BINANCE}/tx`,
    OPTIMISM: `${exports.explorerBaseUrls.OPTIMISM}/tx`,
    FANTOM: `${exports.explorerBaseUrls.FANTOM}/tx`,
    FUSE: `${exports.explorerBaseUrls.FUSE}/tx`,
    MUMBAI: `${exports.explorerBaseUrls.MUMBAI}/tx`,
};
exports.nativeTokenDetails = {
    ETH: {
        name: 'Ether',
        symbol: 'ETH',
        logoUrl: 'https://www.datocms-assets.com/86369/1669619533-ethereum.png',
    },
    POLYGON: {
        name: 'Matic Token',
        symbol: 'MATIC',
        logoUrl: 'https://logos.covalenthq.com/tokens/1/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0.png',
    },
    AVALANCHE: {
        name: 'Avalanche Coin',
        symbol: 'AVAX',
        logoUrl: 'https://www.datocms-assets.com/86369/1686152997-avalanche-colour.png',
    },
    ARBITRUM: {
        name: 'Arbitrum Mainnet Ether',
        symbol: 'ETH',
        logoUrl: 'https://www.datocms-assets.com/86369/1669925028-arbitrum.png',
    },
    BINANCE: {
        name: 'Binance Coin',
        symbol: 'BNB',
        logoUrl: 'https://www.datocms-assets.com/86369/1670003837-biance-smart-chain-colour.png',
    },
    OPTIMISM: {
        name: 'Ether',
        symbol: 'ETH',
        logoUrl: 'https://www.datocms-assets.com/86369/1670347461-optimisim-colour.png',
    },
    FANTOM: {
        name: 'Fantom',
        symbol: 'FTM',
        logoUrl: 'https://www.datocms-assets.com/86369/1669925359-fantom-1.png',
    },
    FUSE: {
        name: 'Fuse',
        symbol: 'FUSE',
        logoUrl: 'https://assets.coingecko.com/coins/images/10347/standard/fuse.png',
    },
    MUMBAI: {
        name: 'Matic Token',
        symbol: 'MATIC',
        logoUrl: 'https://logos.covalenthq.com/tokens/1/0x7d1afa7b718fb893db30a3abc0cfc608aacfebb0.png',
    },
};
exports.ALLCHAINS = [
    'ETH',
    'POLYGON',
    'AVALANCHE',
    'ARBITRUM',
    'BINANCE',
    'OPTIMISM',
    'FANTOM',
    'FUSE',
    'MUMBAI',
];
const isChainSupported = (chainName) => {
    return exports.ALLCHAINS.includes(chainName);
};
exports.isChainSupported = isChainSupported;
